import { render, staticRenderFns } from "./product-discounts.vue?vue&type=template&id=553560b3&"
import script from "./product-discounts.vue?vue&type=script&lang=js&"
export * from "./product-discounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports